<template>
<transition name="fade">
  <div class="ui dimmer page" v-if="showBackDrop" style="display: block !important" :style="{ visibility: showBackDrop ? 'visible' : 'hidden', opacity: showBackDrop ? '1' : '0'}">
    <transition name="scale">
      <div class="ui center aligned middle aligned grid constatus">
        <div class="column">
          <i class="signal huge icon red"></i>
        <h1>Connection to Server Lost!</h1>
            <h2>Trying to reconnect</h2>
<span class="ui active inline loader"></span>

        </div>
      </div>
    </transition>
  </div>
</transition>
</template>

<script>
export default {
  name: 'constatus',
  props: {},

  data() {
    return {
      showBackDrop: false,

    }
  },
  created() {
    if (!!window.EventSource) {
      window.eSource = new EventSource(this.$streamUrl +  "?user=" + this.$getUser()._id)

      window.eSource.onopen = (e) => {
        console.log("Connected")
        this.close()
      };

      window.eSource.onerror = (e) => {
        this.open()
        switch (window.eSource.readyState) {
          case EventSource.CLOSED:
            console.log("Disconnected")
            break

          case EventSource.CONNECTING:
            console.log("Connecting ...")
            break
      }

      }


    } else {
      window.addEventListener('online', (event) => {
        this.close()
      });
      window.addEventListener('offline', (event) => {
        console.log('offline')
        this.open()
      });

    }

  },
  mounted() {
    document.body.classList.add("dimmable");

  },

  destroyed() {
    window.eSource.close()
    delete window.eSource
  },

  methods: {
    open() {
      this.showBackDrop = true
      document.body.classList.add("dimmed");
    },
    close() {
      this.showBackDrop = false
      document.body.classList.remove("dimmed");
    }
  }
}
</script>


<style>
.constatus {
  height: 100vh;
  }
.constatus h1,h2 {color: #fff !important;}

</style>



// WEBPACK FOOTER //
// ConStatus.vue?2e7bb08b